import CancelRoutingGroup from 'actions/routing_groups/cancel_routing_group';
import CollectionState from 'components/lib/collection_state';
import connect from 'components/lib/connect';
import CreateRoutingGroup from 'actions/routing_groups/create_routing_group';
import Endpoint from 'models/endpoint';
import { isVoiceEnabled } from 'components/lib/voice/is_voice_enabled';
import RoutingGroups from 'components/admin/routing_groups';
import UpdateRoutingGroup from 'actions/routing_groups/update_routing_group';

function mapStateToProps(context, props) {
  const { getProvider } = context;
  const routingGroupsProvider = getProvider('routingGroups');
  const agentProfilesProvider = getProvider('agentProfiles');
  const routingGroupsCollectionState = new CollectionState(routingGroupsProvider);

  const getErrors = routingGroupsCollectionState.getErrors;
  const isResponsePending = routingGroupsCollectionState.isResponsePending;
  const isSavePending = routingGroupsCollectionState.isSavePending;

  return {
    enabledChannels: getEnabledChannels(),
    findAgentProfile,
    getErrors,
    isResponsePending,
    isSavePending,
    isVoiceEnabled: isVoiceEnabled(context),
    agentProfilesBinding: props.agentProfiles,
    defaultBinding: props.default,
    rootBinding: props.root,
  };

  function getEnabledChannels() {
    let enabledChannels = [];
    const channelConfiguration = getProvider('channelConfiguration').get();
    if (channelConfiguration) {
      if (channelConfiguration.isChannelEnabled(Endpoint.Type.EMAIL)) {
        enabledChannels.push({ label: 'Default Email Address', type: Endpoint.Type.EMAIL });
      }
      if (channelConfiguration.isChannelEnabled(Endpoint.Type.SMS)) {
        enabledChannels.push({ label: 'Default SMS Number', type: Endpoint.Type.SMS });
      }
      if (channelConfiguration.isChannelEnabled(Endpoint.Type.TWITTER)) {
        enabledChannels.push({ label: 'Default Twitter Handle', type: Endpoint.Type.TWITTER });
      }
      if (channelConfiguration.isChannelEnabled(Endpoint.Type.VOICE)) {
        enabledChannels.push({ label: 'Default Voice Number', type: Endpoint.Type.VOICE });
      }
      if (channelConfiguration.isChannelEnabled(Endpoint.Type.WHATSAPP)) {
        enabledChannels.push({ label: 'Default WhatsApp Number', type: Endpoint.Type.WHATSAPP });
      }
    }

    return enabledChannels;
  }

  function findAgentProfile(id) {
    return agentProfilesProvider.findBy({ id });
  }
}

const mapExecuteToProps = (executeAction, props) => {
  return {
    cancelRoutingGroup: id => executeAction(CancelRoutingGroup, id),
    createRoutingGroup: routingGroupAttrs => executeAction(CreateRoutingGroup, routingGroupAttrs),
    updateRoutingGroup: routingGroupAttrs => executeAction(UpdateRoutingGroup, routingGroupAttrs),

    trackToggleDisabled: (inboxId, disabled) =>
      executeAction(TrackEvent, {
        event: `Admin Inboxes - Toggle Enabled/Disabled`,
        props: { inboxId, disabled },
      }),
  };
};

export default connect(mapStateToProps, mapExecuteToProps)(RoutingGroups);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/routing_groups_container.js